import * as React from 'react'
import { Container } from './Container'
import { topicsData } from './data/topicsData'

export function Topics() {
  return (
    <div className="bg-[#EEF2FF]">
      <Container className="relative py-14 lg:py-24 text-primary-dark">
        <div className="flex items-center justify-between mb-12">
          <h2 className="font-body md:text-6xl lg:text-7xl sm:text-5xl text-4xl font-bold">
            Topics
          </h2>
        </div>
        {topicsData.map((topic, index) => (
          <div key={index} className="border-b border-b-primary-light py-5">
            <p className="text-2xl mb-5">
              <strong>{topic.title}</strong>
            </p>
            <p className="text-xl text-[#1E3A8A]">{topic.description}</p>
          </div>
        ))}
      </Container>
    </div>
  )
}
